module.exports = __webpack_public_path__ + "img/erp_tab01_img_r.df3926bf.png";